import React, { useEffect } from 'react'
import { PageTitle, usePageData } from '../../../../general/layout/core'
import { useIntl } from 'react-intl'
import LogisticsWrapper from './LogisticsWrapper'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import CardLoading from '../components/CardLoading'
import WithPermissionRestricted from '../../../../general/hoc/WithPermissionRestricted'
import { useAuth } from '../../auth'
import { KTCard, KTCardBody, KTIcon } from '../../../../general/helpers'
import { getLogisticsPermissionName } from '../core/helper'

const LogisticsPage = () => {
  const intl = useIntl()
  const { getAllowedPermissionValue } = useAuth()
  const { provider } = useParams()
  const { providers } = usePageData()
  const navigate = useNavigate()
  const activeProvider = providers?.find((providerItem) => providerItem.apiProperty === provider)
  // navigating back to the first available provider in case active retailer is not in list of providers' retailers
  useEffect(() => {
    if (!activeProvider) {
      if (providers?.[0]) {
        navigate(`/logistics/${providers?.[0]?.apiProperty}`)
      }
    }
    // eslint-disable-next-line
  }, [activeProvider, providers])

  if (activeProvider) {
    const hasProviderAccess = getAllowedPermissionValue([
      'logistics',
      `Access${getLogisticsPermissionName(activeProvider.apiProperty.toUpperCase())}`,
    ]);
    if (!hasProviderAccess) {
      // either show a 403 page, or redirect somewhere safe:
      return (
        <>
          <PageTitle>{intl.formatMessage({ id: 'PARCEL.LIST' })}</PageTitle>
          <KTCard className='min-h-450px'>
            <KTCardBody className='d-flex align-items-center justify-content-center'>
              <div className='d-flex flex-column align-items-center gap-8'>
                <div className='d-flex align-items-center gap-1'>
                  <KTIcon iconName='shield-cross' className='fs-2qx' />
                  <p className='m-0 fs-4'>{intl.formatMessage({ id: 'PERMISSION.RESTRICTED' })}</p>
                </div>
                <p className='m-0 fs-4'>{intl.formatMessage({ id: 'PAGE.NO.ACCESS' })}</p>
              </div>
            </KTCardBody>
          </KTCard>
        </>
      )
    }
  }

  return (
    <>
      <PageTitle>
        {`${activeProvider ? activeProvider?.name + ' - ' : ''}${intl.formatMessage({
          id: 'PARCEL.LIST',
        })}`}
      </PageTitle>
      {activeProvider ? <LogisticsWrapper /> : <CardLoading />}
    </>
  )
}

export default WithPermissionRestricted(LogisticsPage, 'PARCEL.LIST', [
  'logistics',
  'GetAllLogistics',
])
